// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__ipts4","blocksContainer":"footer_blocksContainer__C4MBn"};